import { Box, Typography } from "@mui/material";
import pluralize from "pluralize";
import Chart from "react-apexcharts";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ReactComponent as HighSeverity } from "../../../../../icons/icon_files/severity_high.svg";

const ToolPerformanceBox = ({
  compliantControls,
  allControls,
  tool,
  highSeverity,
  chartOptions,
  onClick,
}) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "24px 6px 24px 6px",
        minWidth: "200px",
        cursor: "pointer",
        transition: "transform 0.4s ease-in-out",
        "&:hover": {
          transform: "scale(1.04)",
        },
      }}
      onClick={onClick}
    >
      {/* Upper Icon */}
      <Box
        sx={{
          position: "relative",
        }}
      >
        <CustomToolTip title={tool?.displayName} placement="top">
          <Box>
            <SvgToIcon
              IconLogo={tool?.logo}
              width={48}
              height={48}
              style={{
                background: colors.common_white,
                boxShadow: "0px 0px 2px 1px " + colors.divider2,
                borderRadius: "6px",
                marginBottom: "-8px",
                userSelect: "none",
              }}
            />
          </Box>
        </CustomToolTip>
        {highSeverity && (
          <CustomToolTip title="High severity gaps">
            <Box>
              <SvgToIcon
                IconLogo={HighSeverity}
                width={16}
                height={16}
                style={{
                  position: "absolute",
                  top: "6px",
                  left: "-6px",
                  userSelect: "none",
                }}
              />
            </Box>
          </CustomToolTip>
        )}
      </Box>

      {/* Chart */}
      {chartOptions?.series && (
        <Box sx={{ width: "200px", height: "90px" }}>
          <Chart
            options={chartOptions}
            series={chartOptions?.series}
            type="radialBar"
          />
        </Box>
      )}

      {/* Lower Text */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          style={{
            lineHeight: "16px",
            userSelect: "none",
          }}
        >
          {compliantControls}/{allControls}{" "}
          {pluralize("Control", compliantControls)}{" "}
        </Typography>
        <Typography
          variant="caption"
          style={{
            lineHeight: "16px",
            userSelect: "none",
          }}
        >
          {compliantControls > 1 ? "are" : "is"} compliant
        </Typography>
      </Box>
    </Box>
  );
};

export default ToolPerformanceBox;
